var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamePad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m361 302h30v30h-30z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376 212c-27.847 0-54.214 10.854-73.403 30h-31.597v-60h180v-182h-390v182h180v60h-31.597c-19.189-19.146-45.557-30-73.403-30-57.891 0-105 47.109-105 105v120c0 41.353 33.647 75 75 75 27.686 0 53.101-15.205 66.328-39.741l42.861-80.259h81.621l42.891 80.317c13.198 24.478 38.613 39.683 66.299 39.683 41.353 0 75-33.647 75-75v-120c0-57.891-47.109-105-105-105zm-195 120h-30v30h-30v-30h-30v-30h30v-30h30v30h30zm60 0h-30v-30h30zm60 0h-30v-30h30zm120 0h-30v30h-30v-30h-30v-30h30v-30h30v30h30z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamePad);
export default __webpack_public_path__ + "static/media/game-pad.0e1bc220.svg";
export { ForwardRef as ReactComponent };